var _defs, _polygon, _rect, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceArrowGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 760 240",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "dots-green",
    width: 16,
    height: 16,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2,
    fill: "#bfc4cb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fade-green",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#fff",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "330,10 760,10 760,230 430,230",
    fill: "url(#dots-green)",
    opacity: 0.8
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 0,
    width: 200,
    height: 240,
    fill: "url(#fade-green)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "595,58 642,58 683,120 642,182 595,182 635,120",
    fill: "#36b53f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceArrowGreen);
export default __webpack_public_path__ + "static/media/service-arrow-green.02bf7788895879959a34e2bd07fd1792.svg";
export { ForwardRef as ReactComponent };